import React, { useState } from "react";
const NEON = "#00FF99";

export default function ApprovalQueue({ loading, items, onApprove, onReject, onOverride, onOpen }) {
  const [notes, setNotes] = useState({});
  const set = (id, v) => setNotes(prev => ({ ...prev, [id]: v }));

  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold">Pending Approvals</h3>
        <span className="text-xs text-white/60">{loading ? "loading…" : `${items?.length || 0} requests`}</span>
      </div>

      {loading ? (
        <div className="space-y-3">
          {[...Array(3)].map((_,i)=> <div key={i} className="h-20 rounded-2xl border border-white/10 bg-white/5 animate-pulse" />)}
        </div>
      ) : (items?.length || 0) === 0 ? (
        <p className="text-white/60 text-sm">Nothing pending.</p>
      ) : (
        <div className="space-y-3">
          {items.map(r => (
            <div key={r.id} className="p-3 rounded-2xl border border-white/10 bg-black/30">
              <div className="flex items-center justify-between">
                <div className="text-sm">
                  <button onClick={()=>onOpen?.(r)} className="font-semibold hover:underline" style={{ color: NEON }}>
                    {r.id} — {r.employeeName} ({r.employeeId})
                  </button>
                  <div className="text-white/60">
                    {r.dept} • {r.type} • {r.startDate} → {r.endDate} • {r.days} day(s)
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  {r.conflicts?.blackout && <Badge text="Blackout" />}
                  {r.conflicts?.staffingBelow && <Badge text="Staffing risk" />}
                  {r.conflicts?.teamOff > 0 && <Badge text={`${r.conflicts.teamOff} overlap`} />}
                </div>
              </div>
              <div className="mt-2 flex items-center gap-2">
                <input
                  placeholder="Note (optional)"
                  className="bg-black/30 border border-white/10 rounded-xl px-3 py-1.5 text-sm text-white flex-1"
                  value={notes[r.id] || ""}
                  onChange={e=>set(r.id, e.target.value)}
                />
                <button onClick={()=>onApprove?.(r.id, notes[r.id]||"")}
                  className="text-xs px-3 py-1.5 rounded-full border border-white/10 bg-white/10 hover:bg-white/20">Approve</button>
                <button onClick={()=>onReject?.(r.id, notes[r.id]||"")}
                  className="text-xs px-3 py-1.5 rounded-full border border-white/10 bg-white/10 hover:bg-white/20">Reject</button>
                <button onClick={()=>onOverride?.(r.id, notes[r.id]||"")}
                  className="text-xs px-3 py-1.5 rounded-full border border-white/10"
                  style={{ backgroundColor:"rgba(239,68,68,0.15)", borderColor:"rgba(239,68,68,0.35)" }}
                >Override</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Badge({ text }) {
  return (
    <span className="text-[11px] px-2 py-0.5 rounded-full border"
      style={{ color: NEON, backgroundColor: "rgba(0,255,153,0.12)", borderColor: "rgba(0,255,153,0.35)" }}>
      {text}
    </span>
  );
}
